<template>
  <div class="ecm__books section__padding">
    <h1 class="ecm__books-title">{{ titleBooks }}</h1>
    <div class="ecm__books-container">
      <BooksCard v-if="!activeSkeleton" :books="books" />
      <BooksSkeleton v-else :number="12" />
      <Pagination v-if="total_page > 1 && !activeSkeleton" :total_page="total_page" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BooksCard from '@/components/Books.vue'
import BooksSkeleton from '@/components/skeleton/Books'
import Pagination from '@/components/Pagination'

export default {
  name: 'Books',
  components: {
    BooksCard,
    BooksSkeleton,
    Pagination
  },
  data () {
    return {
      activeSkeleton: true,
      total_page: 0
    }
  },
  mounted () {
    this.$root.$on('fetchBooks', () => {
      this.handleGetBooks()
    })
    this.handleGetBooks()
  },
  watch: {
    $route (route, oldRoute) {
      if (route.query.category) {
        if (route.query.category !== oldRoute.query.category || !oldRoute.query) {
          this.handleGetBooks({ category: route.query.category })
        }
      } else if (route.query.author) {
        if (route.query.author !== oldRoute.query.author || !oldRoute.query) {
          this.handleGetBooks({ author: route.query.author })
        }
      } else if (route.query.publisher) {
        if (route.query.publisher !== oldRoute.query.publisher || !oldRoute.query) {
          this.handleGetBooks({ publisher: route.query.publisher })
        }
      } else if (route.query.title) {
        if (route.query.title !== oldRoute.query.title || !oldRoute.query) {
          this.handleGetBooks({ title: route.query.title })
        }
      } else {
        if (oldRoute.query) {
          this.handleGetBooks()
        }
      }
    }
  },
  computed: {
    ...mapState({
      books: state => state.book.books
    }),
    titleBooks () {
      if (this.$route.query.category) {
        return this.$route.query.category
      } else if (this.$route.query.author) {
        return this.$route.query.author
      } else if (this.$route.query.publisher) {
        return this.$route.query.publisher
      } else if (this.$route.query.title) {
        return this.$route.query.title
      } else {
        return 'All Books'
      }
    }
  },
  methods: {
    ...mapActions({
      fetchBooks: 'book/fetchBooks'
    }),
    async handleGetBooks (query = null) {
      this.$data.activeSkeleton = true
      if (!query) {
        if (this.$route.query.category) {
          query = { category: this.$route.query.category }
        } else if (this.$route.query.author) {
          query = { author: this.$route.query.author }
        } else if (this.$route.query.publisher) {
          query = { publisher: this.$route.query.publisher }
        } else if (this.$route.query.title) {
          query = { title: this.$route.query.title }
        }

        if (this.$route.query.page) {
          query = { ...query, page: this.$route.query.page }
        }
      }

      try {
        const data = await this.fetchBooks({
          limit: 24,
          userId: localStorage.getItem('userId'),
          query
        })
        if (data.status === 'success') {
          setTimeout(() => {
            this.$data.activeSkeleton = false
            this.$data.total_page = data.data.total_page
          }, 1000)
        }
      } catch (error) {
        console.warn(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__books {
  .ecm__books-title {
    color: var(--color-blue);
    text-align: center;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .ecm__books-container {
    .el-col {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}

@media screen and (max-width: 1024px) {
  .ecm__books {
    .ecm__books-title {
      font-size: 30px;
    }
  }
}

@media screen and (max-width: 481px) {
  .ecm__books {
    .ecm__books-title {
      font-size: 25px;
      font-weight: 500;
    }
  }
}
</style>
